import React from "react";
import {
  Dialog,
  DialogContent,
  TextField,
  InputAdornment,
  Box,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from "@mui/material";
import { PrimaryDialogTitle } from "../../Components/Common/Dialog/DialogComponents";
import SurgeryAutoComplete from "../../Components/Patients/SurgeryAutoComplete";
import PrimaryIcon from "../../Components/Common/PrimaryIcon";
import { ReactComponent as SearchIcon } from "Assets/Icons/SearchIcon.svg";
import "../../Sass/Common.scss";
import Button from "../../Components/Common/Button/Button";
import { makeStyles } from "@mui/styles";
import clsx from "clsx";
const GroupAutoComplete = React.lazy(() =>
  import("../../Components/Patients/GroupAutoComplete")
);

const useStyle = makeStyles((theme) => ({
  dayAutocomplete: {
    minWidth: "556px !important",
    fontSize: "14.1px !important",
    marginBottom: "20px",
    [theme.breakpoints.down("768")]: {
      minWidth: "556px !important",
    },
    [theme.breakpoints.down("600")]: {
      minWidth: "100% !important",
    },
    [theme.breakpoints.down("400")]: {
      minWidth: "100% !important",
    },
    "&>div": {
      padding: "10px !important",
    },
  },
  rsUpdateMain: {
    "  & .MuiPaper-root.MuiPaper-elevation": {
      height: "auto !important",
      right: "auto !important",
    },
  },
  rsGroupAutoComplete: {
    marginTop: "31px",
  },
}));

const SearchAndFilterDialogCollectionMobileView = (props) => {
  const {
    open,
    setOpen,
    maxValue,
    surgeryListFlag,
    changeSurgeryDropDownValue,
    handleSurgeryChange,
    searchValue,
    setSearchValue,
    handleSearch,
    groupListFlag,
    changeGroupDropDownValue,
    handleGroupChange,
    showDataBasedOnRole,
    orderDayfilter,
    handleSelectOrderDay,
    orderDayMenuItems,
    setOrderDayValue,
    getList,
    collectedUncollectedListShow,
  } = props;
  const classes = useStyle();
  /** handle close */
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Dialog
        open={open}
        maxWidth={"sm"}
        onClose={(e) => {
          if (e.key === "Escape") {
            handleClose();
          }
        }}
        BackdropProps={{
          classes: {
            root: "root",
          },
        }}
        className={clsx("rsUpdateDialog", classes.rsUpdateMain)}
      >
        <PrimaryDialogTitle handleClose={handleClose} title="Filter" />
        <DialogContent>
          <Box display={"grid"}>
            {showDataBasedOnRole === "user" &&
              collectedUncollectedListShow === "un_collected" && (
                <span>
                  <Select
                    value={orderDayfilter}
                    className={classes.dayAutocomplete}
                    onChange={handleSelectOrderDay}
                    sx={{
                      height: 40,
                    }}
                    MenuProps={{
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                  >
                    {orderDayMenuItems.map((name) => (
                      <MenuItem
                        key={name.index}
                        value={name.lable}
                        onClick={() => {
                          setOrderDayValue(name.value);
                          if (showDataBasedOnRole === "user") {
                            getList({
                              after_order_date_hour: name.value,
                            });
                          }
                        }}
                      >
                        {name.lable}
                      </MenuItem>
                    ))}
                  </Select>
                </span>
              )}
            <SurgeryAutoComplete
              fullWidth
              multiple
              maxValue={maxValue}
              surgeryListFlag={surgeryListFlag}
              className="autoCompleteBoxMob"
              value={Object.values(changeSurgeryDropDownValue || [])}
              handleChange={(value) => handleSurgeryChange(value)}
              renderInput={(params) => (
                <TextField {...params} label="Surgeries" />
              )}
            />
            <TextField
              withPadding={true}
              medium
              secondary
              className="rsSearchMobFilter"
              placeholder="Search..."
              value={searchValue}
              onChange={(e) => {
                handleSearch(e?.target?.value);
                setSearchValue(e?.target?.value);
              }}
              InputProps={{
                endAdornment: (
                  <>
                    <InputAdornment position="end">
                      <PrimaryIcon width="20px" icon={SearchIcon} />
                    </InputAdornment>
                  </>
                ),
              }}
            />
            <GroupAutoComplete
              fullWidth
              multiple
              className={clsx(
                "autoCompleteBoxMob",
                classes.rsGroupAutoComplete
              )}
              maxValue={maxValue}
              groupListFlag={groupListFlag}
              value={changeGroupDropDownValue}
              handleChange={(value) => handleGroupChange(value)}
              renderInput={(params) => (
                <TextField {...params} label="Group List" />
              )}
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            children="Filter"
            variant="outlined"
            onClick={(e) => handleClose()}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default SearchAndFilterDialogCollectionMobileView;
